import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter, tap, delay } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';

import * as rootReducer from 'app/core/store';
import * as fromActions from 'app/core/store/actions/auth.actions';
import * as fromAuthSelectors from 'app/core/store/selectors/auth.selectors';
import { FormValidator } from '../form-validator';
import { ValidationMessages } from '../modal-registration/modal-registration.constants';

@Component({
  standalone: false,
  selector: 'pptl-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../auth.component.scss', './reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordComponent implements OnInit, OnDestroy, AfterViewInit {
  resetError$: Observable<any>;
  resetSubscription: Subscription;
  resetPassForm: FormGroup;
  errorMsgsHint = [];
  readonly validationMessages = ValidationMessages;
  public typePass = 'password';
  public typeRePass = 'password';
  public showPass = false;
  public showRePass = false;
  private userKey = '';

  inputDisplay = false;
  resetErrorMessage: string | null;

  constructor(
    private fb: FormBuilder,
    private store: Store<rootReducer.State>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private platform: Platform,
  ) {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.userKey = params && params.userPasswordResetCd;
    });
  }

  ngOnInit() {
    this.initResetPassForm();
    this.resetSubscription = this.store
      .pipe(
        select(fromAuthSelectors.getResetStatus),
        tap((res: any) => {
          this.inputDisplay = !!res;
        }),
        filter((res: any) => !!res),
        delay(5000),
        tap(() => {
          if (this.resetErrorMessage) {
            this.store.dispatch(fromActions.SetDefaultResetStatus());
          }
        }),
      )
      .subscribe();

    this.resetError$ = this.store.pipe(
      select(fromAuthSelectors.getAuthError),
      tap((res: any) => {
        this.resetErrorMessage = res.resetErrorMessage;
      }),
    );
  }

  ngAfterViewInit(): void {
    this.platform.ready().then(() => {
      SplashScreen.hide();
    });
  }

  ngOnDestroy() {
    this.resetSubscription.unsubscribe();
    this.store.dispatch(fromActions.ClearResetStatus());
    this.inputDisplay = false;
  }

  initResetPassForm(): void {
    this.resetPassForm = this.fb.group(
      {
        password: [
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(32),
            FormValidator.upperCase,
            FormValidator.lowerCase,
            FormValidator.digits,
            FormValidator.specialSymbol,
            FormValidator.noWhiteSpace,
          ]),
        ],
        rePassword: ['', Validators.required],
      },
      {
        validator: FormValidator.passwordCompare.bind(this),
      },
    );
  }

  onSubmit() {
    this.store.dispatch(
      fromActions.ResetPassword({
        payload: {
          password: this.resetPassForm.controls.password.value,
          confirmPassword: this.resetPassForm.controls.rePassword.value,
          userKey: this.userKey,
        },
      }),
    );
  }

  getValidClass(controlName: string, errorTypeField: string): string {
    return FormValidator.getValidClass(controlName, errorTypeField, this.resetPassForm);
  }

  redirectToLogin() {
    this.router.navigate(['/auth/login'], { replaceUrl: true });
  }

  clearFields() {
    this.resetPassForm.reset();
  }

  showPassword() {
    this.showPass = !this.showPass;
    this.typePass = this.showPass ? 'text' : 'password';
  }

  showRePassword() {
    this.showRePass = !this.showRePass;
    this.typeRePass = this.showRePass ? 'text' : 'password';
  }

  get isDevicePlatform(): boolean {
    return  false;
  }
}
